import { render, staticRenderFns } from "./AdminWizard.vue?vue&type=template&id=469fe0cc&scoped=true&"
import script from "./AdminWizard.vue?vue&type=script&lang=js&"
export * from "./AdminWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469fe0cc",
  null
  
)

export default component.exports